import { Prismic, fallbackImage, fallbackText } from '@landsbankinn/prismic';
import Head from 'next/head';
import React from 'react';
import Meta from '../components/templates/meta/Meta';

interface IProps {
  data: any;
  breadcrumbs?: any;
  defaultTitle?: Prismic.RichText;
  defaultImage?: Prismic.Image;
  defaultDescription?: Prismic.RichText;
  author?: string;
  isFrontPage?: boolean;
  type?: 'page' | 'article';
  canonicalUrlBase?: string;
  siteName?: string;
}

function SchemaOrgBreadcrumbs({ items, canonicalUrlBase }: any) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items.map((item: any, index: number) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.title,
            item: `${canonicalUrlBase}${item.url}`,
          })),
        }),
      }}
    />
  );
}

export const MetaContainer = ({
  data,
  breadcrumbs,
  defaultTitle,
  defaultImage,
  defaultDescription,
  author = undefined,
  isFrontPage = false,
  canonicalUrlBase,
  type = 'page',
  siteName,
}: IProps) => {
  let seoTitle = fallbackText(data.seo_title, data.page_title, data.title);
  let title = fallbackText(data.seo_title, data.page_title, data.title);
  const seoDescription = fallbackText(
    data?.seo_description,
    data?.abstract,
    defaultDescription,
  );

  const seoImage = fallbackImage(
    data?.seo_image,
    data?.abstract_image,
    defaultImage?.seo,
  );

  if (breadcrumbs && breadcrumbs.length && !data.seo_title) {
    // Render breadrumbs as title
    seoTitle = breadcrumbs
      .slice()
      .reverse()
      .map((p: any) => p.title)
      .join(' - ');
  }

  title = isFrontPage
    ? seoTitle
    : (`${seoTitle} - ${Prismic.text(defaultTitle)}` as string);

  // Canonical url is doing more harm than good as is, needs a refactor/rethink
  /*   const canonicalUrl = `${CANONICAL_URL_BASE}${linkResolver({
    ...data?._meta,
    type,
  })}`; */

  return (
    <>
      <Head>
        {breadcrumbs && (
          <SchemaOrgBreadcrumbs
            items={breadcrumbs}
            canonicalUrlBase={canonicalUrlBase}
          />
        )}
        {/* <link href={canonicalUrl} rel="canonical" /> */}
      </Head>
      <Meta
        title={title ?? ''}
        seoTitle={seoTitle ?? undefined}
        description={seoDescription as string}
        image={seoImage?.seo ? seoImage?.seo?.url : seoImage?.url}
        imageAlt={seoImage?.alt}
        author={author}
        siteName={siteName ?? undefined}
      />
    </>
  );
};
